import React from 'react'
import { useTranslation } from 'react-i18next'
import ButtonBase from '@mui/material/ButtonBase'
import {
  Counter1,
  Counter2,
  Counter3,
  Counter4,
  Counter5,
  Counter6,
  Counter7,
  Fullscreen,
  OneXMobiledata,
  Pause,
  PlayArrow,
  SkipNext,
  SkipPrevious,
  Speed05X,
  Speed15X,
  Speed2X,
} from '@vedmarket/ui-kit'

const stepIcons = [ Counter1, Counter2, Counter3, Counter4, Counter5, Counter6, Counter7 ]
const speeds = [
  { value: .5, Icon: Speed05X },
  { value: 1, Icon: OneXMobiledata },
  { value: 1.5, Icon: Speed15X },
  { value: 2, Icon: Speed2X },
]

const DemoPlayerControls = ({ paused, step, speed, isFullscreen, onToggle, onSeek, onSpeed, onFullscreen }: DemoPlayerControlsProps) => {
  const { t } = useTranslation()
  const PlaybackIcon = paused ? PlayArrow : Pause

  return <>
    <div className='demo-player-controls'>
      <div className='demo-player-controls__group'>
        <ButtonBase className='demo-player-controls__button' disabled={step === 0} aria-label={t('calc__demoPlayer__previous')} onClick={() => onSeek(step - 1)}>
          <SkipPrevious className='demo-player-controls__icon' width={32} height={32} />
        </ButtonBase>
        <ButtonBase className='demo-player-controls__button' aria-label={t(paused ? 'calc__demoPlayer__play' : 'calc__demoPlayer__pause')} onClick={onToggle}>
          <PlaybackIcon className='demo-player-controls__icon' width={32} height={32} />
        </ButtonBase>
        <ButtonBase className='demo-player-controls__button' disabled={step === 6} aria-label={t('calc__demoPlayer__next')} onClick={() => onSeek(step + 1)}>
          <SkipNext className='demo-player-controls__icon' width={32} height={32} />
        </ButtonBase>
      </div>
      <div className='demo-player-controls__group'>
        {speeds.map(({ value, Icon }) => (
          <ButtonBase
            key={value}
            className='demo-player-controls__button'
            aria-label={t('calc__demoPlayer__speed', { value })}
            aria-pressed={speed === value}
            onClick={() => onSpeed(value)}
          >
            <Icon className='demo-player-controls__icon' width={32} height={32} />
          </ButtonBase>
        ))}
      </div>
      <ButtonBase
        className='demo-player-controls__button demo-player-controls__button_fullscreen'
        aria-label={t(isFullscreen ? 'calc__demoPlayer__exitFullscreen' : 'calc__demoPlayer__fullscreen')}
        aria-pressed={isFullscreen}
        onClick={onFullscreen}
      >
        <Fullscreen className='demo-player-controls__icon' width={32} height={32} />
      </ButtonBase>
    </div>
    <div className='demo-player-controls'>
      {stepIcons.map((Icon, index) => (
        <ButtonBase
          key={index}
          className='demo-player-controls__button'
          aria-label={t('calc__demoPlayer__step', { value: index + 1 })}
          aria-pressed={step === index}
          onClick={() => onSeek(index)}
        >
          <Icon className='demo-player-controls__icon' width={32} height={32} />
        </ButtonBase>
      ))}
    </div>
  </>
}

export default DemoPlayerControls
